var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"category_card_outer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"category_card_inner flx"},_vm._l((_vm.items),function(item,i){return _c('category-card',{key:i,attrs:{"category":item}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }